import React from "react";
import { UploadDocComponent, ModalTemplate } from "../../reusableComponent";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  uploadProjectIssuesAction,
  clearUploadProjectIssuesAction
} from "../../../actions/dowloadExcelActions";
import { toast } from "react-toastify";
import { FormDataForImage, isValidArray } from "../../../helper";
import { successToastStyle, errorToastStyle } from "../../../customToast";
import { UploadProjectIssuesModal } from "../modal/uploadProjectIssuesModal";
class BrowseUpload extends React.PureComponent {
  state = {
    toggleUploadPopUp: false,
    listofFiles: [],
    showUploadResultModal: false
  };

  // upload files
  onUploadFile = e => {
    try {
      const { files } = e.target;
      const filesArr = [];
      // only on file can upload
      if (files.length > 1) {
        toast.error(
          <p className="toast-text-alignment">Only one file can be uploaded</p>,
          errorToastStyle
        );
        return false;
      }
      // extract the files
      for (let index = 0; index < files.length; index++) {
        const file = files[index];
        if (
          file.type !== "text/csv" &&
          file.type !== "application/vnd.ms-excel" &&
          file.type !==
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ) {
          toast.error(
            <p className="toast-text-alignment">Only csv can be uploaded.</p>,
            errorToastStyle
          );
          return false;
        }
        filesArr.push(file);
      }
      this.setState({
        listofFiles: filesArr
      });
    } catch (error) {
      console.error(error);
    }
  };

  // on submit upload files
  onSubmitFile = async () => {
    const { uploadProjectIssuesAction, onUploadToggle } = this.props;

    try {
      const { listofFiles } = this.state;
      // if files is attached then upload will begin
      if (isValidArray(listofFiles)) {
        let formData = FormDataForImage(listofFiles, "file");
        const response = await uploadProjectIssuesAction(formData);
        console.log("response", response);

        if (response && response.status) {
          //console.log('uploaded data', uploadedList);
          this.setState({
            toggleUploadPopUp: false,
            listofFiles: []
          });
          //clearUploadProjectIssuesAction();
          onUploadToggle();
        }
      } else {
        // if not file is attached
        toast.error(
          <p className="toast-text-alignment">
            No file is for uploading. Please attach a file.
          </p>,
          errorToastStyle
        );
      }
    } catch (error) {
      this.setState({ toggleUploadPopUp: false, listofFiles: [] });
      onUploadToggle();
      console.log(error);
    }
  };

  closeUploadedListModal = () => {
    this.setState({ showUploadResultModal: false });
  };

  render() {
    const {
      state: { listofFiles },
      props: { uploadProjectIssuesReducer, onUploadToggle, uploadedList },
      onSubmitFile,
      onUploadFile
    } = this;
    return (
      <>
        <UploadProjectIssuesModal
          centered
          isLoading={uploadProjectIssuesReducer.isLoading}
          containerClass="download-upload-popup"
          onClose={onUploadToggle}
          template={
            <ModalTemplate
              onClose={onUploadToggle}
              onSubmit={onSubmitFile}
              onSubmitTitle="Upload"
              onCloseTitle="Close"
              headerTitle="Upload File"
              submitDisable={!(isValidArray(listofFiles) && listofFiles.length)}
              bodyTemplate={
                <>
                  <UploadDocComponent
                    filesName={listofFiles.map(value => value.name).toString()}
                    feedback="* .xlsx file upto 5MB"
                    extensions=".xlsx"
                    onUpload={onUploadFile}
                  />
                  {isValidArray(listofFiles) ? (
                    <>
                      <div className="upload-project-issues-browse-body">
                        <div className="title">File Name</div>
                        {listofFiles.map(value => (
                          <div key={value.name} className="uploded-image-names">
                            {value.name}
                          </div>
                        ))}
                      </div>
                    </>
                  ) : null}
                </>
              }
            />
          }
        />
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    uploadProjectIssuesReducer: state.donwloadExcelReducer.uploadProjectIssues,
    uploadedList: state.donwloadExcelReducer.uploadProjectIssues.uploadedList
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      uploadProjectIssuesAction,
      clearUploadProjectIssuesAction
    },
    dispatch
  );
}

const BrowseUploadComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(BrowseUpload);
export { BrowseUploadComponent };
